import { Card, Tabs } from 'antd';
import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { TitleBreadcrumbs } from '../../uiComponents/TitleBreadcrumbs';
import { SystemHistoryTable } from '../../components/SystemLogs/SystemLogTable';
import { moduleDictionary } from '../../../constants/Logs.const';
import { columns } from '../../../constants/SystemHistory';

export const SystemHistory = () => {
  const {
    privileges: { systemLogs = [] },
  } = useSelector((state) => state.userAuth);

  const [activeKey, setActiveKey] = useState('blocks');

  // contador por tab para forzar remount en cada click
  const [clickVersion, setClickVersion] = useState({
    blocks: 0,
    users: 0,
    customers: 0,
  });

  const bump = (key) =>
    setClickVersion((v) => ({ ...v, [key]: v[key] + 1 }));

  const items = useMemo(
    () => [
      {
        key: 'blocks',
        label: 'Bloqueos',
        children: (
          <SystemHistoryTable
            key={`blocks-${clickVersion.blocks}`} // remount en cada click
            privileges={systemLogs}
            module={moduleDictionary.locks}
            columns={columns}
          />
        ),
      },
      {
        key: 'users',
        label: 'Usuarios',
        children: (
          <SystemHistoryTable
            key={`users-${clickVersion.users}`}
            privileges={systemLogs}
            module={moduleDictionary.users}
            columns={columns}
          />
        ),
      },
      {
        key: 'customers',
        label: 'Clientes',
        children: (
          <SystemHistoryTable
            key={`customers-${clickVersion.customers}`}
            privileges={systemLogs}
            module={moduleDictionary.customers}
            columns={columns}
          />
        ),
      },
    ],
    [systemLogs, clickVersion]
  );

  return (
    <Card title={<TitleBreadcrumbs />} bordered className="gx-card">
      <Tabs
        type="card"
        activeKey={activeKey}
        destroyInactiveTabPane
        items={items}
        onChange={(key) => {
          const k = key
          setActiveKey(k);
          bump(k); // cuando cambias de tab, remount
        }}
        onTabClick={(key) => {
          bump(key); // cuando clickeas el mismo tab activo, remount
        }}
      />
    </Card>
  );
};
